import { CATEGORY_LINKS } from "./index.content";
import productDatabase from "./ProductResearchTools/productDatabase";
import proAiExtension from "./ProductResearchTools/proAiExtension";
import quickView from "./ProductResearchTools/quickView";
import dropshipping from "./ProductResearchTools/dropshipping";
import productKeywordsLookup from "./KeywordsAndProductListingTools/productKeywordsLookup";
import keywordSearch from "./KeywordsAndProductListingTools/keywordSearch";
import keywordTracker from "./KeywordsAndProductListingTools/keywordTracker";
import aiListingBuilder from "./KeywordsAndProductListingTools/aiListingBuilder";
import feesCalculatorForAmazonFBA from "./FreeTools/feesCalculatorForAmazonFBA";
import stockStats from "./FreeTools/stockStats";
import salesEstimator from "./FreeTools/salesEstimator";
import monthlyReports from "./TrendsAndProductIdeas/monthlyReports";
import weeklyHotProducts from "./TrendsAndProductIdeas/weeklyHotProducts";
import individualProductResearch from "./TrendsAndProductIdeas/individualProductResearch";
import freeBonuses from "./TrendsAndProductIdeas/freeBonuses";
import stepByStepCourses from "./LearningOpportunities/stepByStepCourses";
import masterclasses from "./LearningOpportunities/masterclasses";
import onDemandTraining from "./LearningOpportunities/onDemandTraining";
import blog from "./LearningOpportunities/blog";
import companyPartners from "./Partnerships/companyPartners";
import affiliateProgram from "./Partnerships/affiliateProgram";
import testimonials from "./Partnerships/testimonials";
import aboutUs from "./Company/aboutUs";
import termsOfUse from "./Company/termsOfUse";
import usingAMZScoutIs100PercentSafe from "./Company/usingAMZScoutIs100PercentSafe";
import privacyPolicy from "./Policies/privacyPolicy";
import vulnerabilitiesDisclosurePolicy from "./Policies/vulnerabilitiesDisclosurePolicy";
import aiReviewAnalyzer from "./KeywordsAndProductListingTools/aiReviewAnalyzer";

const updateLinks = ({ language, isSavedUser }) => {
  const generateCategory = (category, links) => ({
    category: CATEGORY_LINKS[category],
    links: links.map((link) => link({ language, isSavedUser })),
  });
  return [
    generateCategory("PRODUCT_RESEARCH_TOOLS", [
      productDatabase,
      proAiExtension,
      quickView,
      dropshipping,
    ]),
    generateCategory("KEYWORD_AND_LISTING_TOOLS", [
      productKeywordsLookup,
      keywordSearch,
      keywordTracker,
      aiListingBuilder,
      aiReviewAnalyzer,
    ]),
    generateCategory("FREE_TOOLS", [
      feesCalculatorForAmazonFBA,
      stockStats,
      salesEstimator,
    ]),
    generateCategory("TRENDS_AND_PRODUCT_IDEAS", [
      monthlyReports,
      weeklyHotProducts,
      individualProductResearch,
      freeBonuses,
    ]),
    generateCategory("LEARNING_OPPORTUNITIES", [
      stepByStepCourses,
      masterclasses,
      onDemandTraining,
      blog,
    ]),
    generateCategory("PARTNERSHIPS", [
      companyPartners,
      affiliateProgram,
      testimonials,
    ]),
    generateCategory("COMPANY", [
      aboutUs,
      termsOfUse,
      usingAMZScoutIs100PercentSafe,
    ]),
    generateCategory("POLICIES", [
      privacyPolicy,
      vulnerabilitiesDisclosurePolicy,
    ]),
  ];
};
export default updateLinks;
